import React from 'react'
import propTypes from 'prop-types'
import { Button } from '..'
import { CloseRoundedIcon } from '../../../theme/icons'

export const CustomPopup = React.memo(({ onCloseDialog, content, children }) => {
    const { title, loading, maxWidth = "max-w-sm" } = content;

    return (<div className="border-secondary-400">
        <div className="p-15 bg-white/44 backdrop-blur-sm rounded-t-lg">
            <div className={` sm:${maxWidth} flex justify-between items-between w-full md:max-w-full`}>
                <h2 className="text-secondary-500 font-semibold truncate whitespace-break-spaces text-md">{title}</h2>
                <Button text="" disabled={loading} className="p-0" onClick={onCloseDialog} variant="tertiary" icon={<CloseRoundedIcon />} />
            </div>
        </div>
        <div className="p-15 bg-white rounded-b-lg">
            {children}
        </div>
    </div>)

})

CustomPopup.propTypes = {
    onCloseDialog: propTypes.func,
    content: propTypes.object,
    children: propTypes.node,
}

CustomPopup.defaultProps = {
    onCloseDialog: () => null,
    content: {
        title: "", loading: false
    },
    children: <></>
}